import { Fragment, useEffect, useState } from "react";
import styles from "../Table/index.module.scss";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  ButtonGroup,
  Button,
  FormGroup,
  Input,
  ModalFooter,
} from "reactstrap";
import { useMutation, useQuery } from "@apollo/client";
import {
  ANSWER_ACCEPT_INVITATION,
  ANSWER_DENY_INVITATION,
  ANSWER_REJECT_INVITATION,
} from "../mutations";
import { useParams, Link } from "react-router-dom";
import moment from "moment";
import { FETCH_INTERVIEW_INVITATION } from "../queries";
import toggleStyles from "./message.module.scss";
import { useHistory } from "react-router-dom";
import LaddaButton, { EXPAND_LEFT } from "react-ladda";

const ModalAnswerInvitation = (props) => {
  const { open, setOpenAnswerInvitation, refetchStatus } = props;
  const params = useParams();
  const history = useHistory();
  const [tool, setTool] = useState();
  const [message, setMessage] = useState("");
  const [interviewDate, setInterviewDate] = useState("");

  const [mutateInvitation, { loading: isLoadingMutateInvitation }] =
    useMutation(ANSWER_ACCEPT_INVITATION);
  const [mutateCancelInvitation] = useMutation(ANSWER_DENY_INVITATION);
  const [mutateRejectInvitation] = useMutation(ANSWER_REJECT_INVITATION);

  const { data: dataInvitation } = useQuery(FETCH_INTERVIEW_INVITATION, {
    fetchPolicy: "no-cache",
    variables: { collaborationStatusId: params.id },
  });

  const [modalReview, setModalReview] = useState(false);
  const toggleReview = () => setModalReview(!modalReview);

  const [modalCancel, setModalCancel] = useState(false);
  const toggleCancel = () => setModalCancel(!modalCancel);

  const [modalReject, setModalReject] = useState(false);
  const toggleReject = () => setModalReject(!modalReject);
  const [rejectMessage, setRejectMessage] = useState("");

  const [modalSuccessPage, setModalSuccessPage] = useState(false);
  const toggleSuccessPage = () => setModalSuccessPage(!modalSuccessPage);

  const [interviewIds, setInterviewIds] = useState(null);

  const toolSelection = (data) => {
    setTool(data);
  };

  const handleReviewSubmit = () => {
    toggleReview();
  };

  useEffect(() => {
    if (dataInvitation) {
      setInterviewIds(
        dataInvitation?.getMyInterviewInvitations?.edges[0].node?.id
      );
    }
  }, [dataInvitation]);

  const handleSubmitInvitation = () => {
    mutateInvitation({
      variables: {
        interviewDate: interviewDate,
        message: message,
        interviewInvitationId: interviewIds,
      },
    })
      .then((response) => {
        toggleReview();
        toggleSuccessPage();
        setOpenAnswerInvitation(false);
        // setOpenAnswerInvitation(!open)
        refetchStatus();
        // history.push('/dashboard/organization-partnership')
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCancelInvitation = () => {
    mutateCancelInvitation({
      variables: {
        interviewInvitationId: interviewIds,
      },
    })
      .then((response) => {
        toggleCancel();
        setOpenAnswerInvitation(!open);
        // toggleSuccessPage()
        // setOpenAnswerInvitation(!open)
        refetchStatus();
        // history.push('/dashboard/organization-partnership')
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRejectInvitation = () => {
    mutateRejectInvitation({
      variables: {
        collaborationStatusId: params.id,
        message: rejectMessage,
      },
    })
      .then((response) => {
        // toggleCancel()
        // setOpenAnswerInvitation(!open)
        // refetchStatus()
        history.push("/dashboards/organization-partnership");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Fragment>
      <div className={styles["create-modal-invitation"]}>
        <Modal
          isOpen={open}
          toggle={() => setOpenAnswerInvitation(!open)}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={() => setOpenAnswerInvitation(!open)}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              面談調整
            </div>
            <div className="text-center">
              <ButtonGroup className="mb-4">
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "zoom" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("zoom")}
                    active={tool === "zoom"}
                    disabled
                  >
                    Zoom
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "google_meet" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("google_meet")}
                    active={tool === "google_meet"}
                    disabled
                  >
                    Google Meet
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "teams" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("teams")}
                    active={tool === "teams"}
                    disabled
                  >
                    Teams
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "その他" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("その他")}
                    active={tool === "その他"}
                    disabled
                  >
                    その他
                  </Button>
                )}
              </ButtonGroup>
            </div>
            <FormGroup>
              <Label>
                候補日
                <span className="badge__required">必須</span>
              </Label>
            </FormGroup>
            <div className="mb-4">
              {!!dataInvitation?.getMyInterviewInvitations?.edges[0].node
                ?.candidateDate1 && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="candidateDate"
                      value={
                        dataInvitation?.getMyInterviewInvitations?.edges[0].node
                          ?.candidateDate1
                      }
                      onChange={(e) => setInterviewDate(e.target.value)}
                    />{" "}
                    {moment(
                      dataInvitation?.getMyInterviewInvitations?.edges[0].node
                        ?.candidateDate1
                    ).format("YYYY年MM月DD日 HH:mm")}
                  </Label>
                </FormGroup>
              )}
              {!!dataInvitation?.getMyInterviewInvitations?.edges[0].node
                ?.candidateDate2 && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="candidateDate"
                      value={
                        dataInvitation?.getMyInterviewInvitations?.edges[0].node
                          ?.candidateDate2
                      }
                      onChange={(e) => setInterviewDate(e.target.value)}
                    />{" "}
                    {moment(
                      dataInvitation?.getMyInterviewInvitations?.edges[0].node
                        ?.candidateDate2
                    ).format("YYYY年MM月DD日 HH:mm")}
                  </Label>
                </FormGroup>
              )}
              {!!dataInvitation?.getMyInterviewInvitations?.edges[0].node
                ?.candidateDate3 && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="candidateDate"
                      value={
                        dataInvitation?.getMyInterviewInvitations?.edges[0].node
                          ?.candidateDate3
                      }
                      onChange={(e) => setInterviewDate(e.target.value)}
                    />{" "}
                    {moment(
                      dataInvitation?.getMyInterviewInvitations?.edges[0].node
                        ?.candidateDate3
                    ).format("YYYY年MM月DD日 HH:mm")}
                  </Label>
                </FormGroup>
              )}
              {!!dataInvitation?.getMyInterviewInvitations?.edges[0].node
                ?.candidateDate4 && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="candidateDate"
                      value={
                        dataInvitation?.getMyInterviewInvitations?.edges[0].node
                          ?.candidateDate4
                      }
                      onChange={(e) => setInterviewDate(e.target.value)}
                    />{" "}
                    {moment(
                      dataInvitation?.getMyInterviewInvitations?.edges[0].node
                        ?.candidateDate4
                    ).format("YYYY年MM月DD日 HH:mm")}
                  </Label>
                </FormGroup>
              )}
              {!!dataInvitation?.getMyInterviewInvitations?.edges[0].node
                ?.candidateDate5 && (
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="candidateDate"
                      value={
                        dataInvitation?.getMyInterviewInvitations?.edges[0].node
                          ?.candidateDate5
                      }
                      onChange={(e) => setInterviewDate(e.target.value)}
                    />{" "}
                    {moment(
                      dataInvitation?.getMyInterviewInvitations?.edges[0].node
                        ?.candidateDate5
                    ).format("YYYY年MM月DD日 HH:mm")}
                  </Label>
                </FormGroup>
              )}
            </div>
            {/* <FormGroup check>
              <Label check className="mb-4">
                <Input type="radio" name="candidateDate" value={dataInvitation?.getMyInterviewInvitations?.edges[0].node?.candidateDate2} onChange={(e) => setInterviewDate(e.target.value)} /> Set Another Date
              </Label>
            </FormGroup> */}
            <FormGroup>
              <Label>URL</Label>
              <p>
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node?.url}
              </p>
              {/* <Input disabled type="text" name="url" className="form-control" onChange={(e) => setUrl(e.target.value)} placeholder="https://example.com" /> */}
            </FormGroup>
            <FormGroup>
              <Label>メッセージ</Label>
              <p>
                {
                  dataInvitation?.getMyInterviewInvitations?.edges[0].node
                    ?.message
                }
              </p>
              {/* <Input disabled type="textarea" name="message" className="form-control" onChange={(e) => setMessage(e.target.value)} placeholder="自由記述" /> */}
            </FormGroup>
            <FormGroup>
              <Label>その他</Label>
              <Input
                type="textarea"
                rows={4}
                name="message"
                className="form-control"
                onChange={(e) => setMessage(e.target.value)}
                placeholder="自由記述"
              />
            </FormGroup>
            <FormGroup>
              <Button
                style={{ padding: "12px" }}
                block
                onClick={handleReviewSubmit}
                disabled={interviewDate === "" && true}
              >
                次へ
              </Button>
              <Button
                style={{ padding: "12px" }}
                block
                className={toggleStyles["toggle-btn-close"]}
                onClick={toggleCancel}
              >
                日時を再調整する
              </Button>
              <Button
                style={{ padding: "12px" }}
                block
                outline
                color="focus"
                className="pl-4 pr-4"
                onClick={toggleReject}
              >
                今回の連携を見送る
              </Button>
            </FormGroup>
          </ModalBody>
        </Modal>
      </div>
      <div className={styles["review-invitation"]}>
        <Modal
          isOpen={modalReview}
          toggle={toggleReview}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggleReview}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              面談調整
            </div>
            <div className="text-center">
              <ButtonGroup className="mb-4">
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "zoom" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("zoom")}
                    active={tool === "zoom"}
                    disabled
                  >
                    Zoom
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "google_meet" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("google_meet")}
                    active={tool === "google_meet"}
                    disabled
                  >
                    Google Meet
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "teams" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("teams")}
                    active={tool === "teams"}
                    disabled
                  >
                    Teams
                  </Button>
                )}
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node
                  ?.tool === "その他" && (
                  <Button
                    outline
                    color="primary"
                    onClick={() => toolSelection("その他")}
                    active={tool === "その他"}
                    disabled
                  >
                    その他
                  </Button>
                )}
              </ButtonGroup>
            </div>
            <FormGroup>
              <Label>候補日</Label>
              <h5>
                {interviewDate !== "" &&
                  moment(interviewDate).format("YYYY年MM月DD日 HH:mm")}
              </h5>
            </FormGroup>
            <FormGroup>
              <Label>URL</Label>
              <h5>
                {dataInvitation?.getMyInterviewInvitations?.edges[0].node?.url}
              </h5>
            </FormGroup>
            <FormGroup>
              <Label>メッセージ</Label>
              <h5>
                {
                  dataInvitation?.getMyInterviewInvitations?.edges[0].node
                    ?.message
                }
              </h5>
            </FormGroup>
            <FormGroup>
              <Label>その他</Label>
              <h5>{message}</h5>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {/* <Button
              style={{ backgroundColor: "#44CAE1", borderColor: "#44CAE1" }}
              className="pl-4 pr-4"
              onClick={handleSubmitInvitation}
            >
              送信
            </Button> */}
            <LaddaButton
              className="mb-2 mr-2 btn btn-info"
              style={{ backgroundColor: "#44CAE1", borderColor: "#44CAE1" }}
              loading={isLoadingMutateInvitation}
              onClick={handleSubmitInvitation}
              data-style={EXPAND_LEFT}
            >
              送信
            </LaddaButton>
          </ModalFooter>
        </Modal>
      </div>
      <div className={styles["alert-invitation"]}>
        <Modal
          isOpen={modalSuccessPage}
          toggle={toggleSuccessPage}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggleSuccessPage}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody className="mb-5">
            <div
              className="text-center mb-5"
              style={{ fontSize: "20px", fontWeight: "400" }}
            >
              面談調整
            </div>
            <div className="text-center">
              <div className="mb-4">
                送信完了 <br />
              </div>

              <div className="mb-5" style={{ color: "#FF4444" }}>
                が組織情報を確認するため <br />
                情報をアップデートしましょう。
              </div>

              <Link
                style={{
                  padding: "9px 25px",
                  backgroundColor: "#44CAE1",
                  border: "none",
                  color: "white",
                  borderRadius: "5px",
                  marginBottom: "30px",
                }}
                to="/dashboards/plofile-organization/"
              >
                {"情報をアップデート"}
              </Link>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="focus"
              style={{ backgroundColor: "#8D8D8D", borderColor: "#8D8D8D" }}
              onClick={toggleSuccessPage}
            >
              閉じる
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      <div className={styles["cancel-invitation"]}>
        <Modal
          isOpen={modalCancel}
          toggle={toggleCancel}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggleCancel}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              面談日時を再調整する
            </div>

            <div className="text-center">
              メッセージページから「この組織と面談する」をクリックし再度 <br />
              面談候補日を設定してください。
            </div>

            <Button
              style={{ padding: "12px", marginTop: "30px" }}
              block
              className={toggleStyles["toggle-btn"]}
              // onClick={toggleCancel}
              onClick={handleCancelInvitation}
            >
              面談を再調整する
            </Button>
          </ModalBody>
        </Modal>
      </div>
      <div className={styles["reject-invitation"]}>
        <Modal
          isOpen={modalReject}
          toggle={toggleReject}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggleReject}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              連携を見送る
            </div>

            <div className="text-center">
              送信ボタンを押すと
              <br />
              この組織との連携は見送られます。
            </div>
            <FormGroup>
              <Label>その他</Label>
              <Input
                type="textarea"
                name="reject_message"
                className="form-control"
                onChange={(e) => setRejectMessage(e.target.value)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              style={{ backgroundColor: "#44CAE1", borderColor: "#44CAE1" }}
              className="pl-4 pr-4"
              onClick={handleRejectInvitation}
            >
              送信
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
};

export default ModalAnswerInvitation;
